import React, { useEffect, useState } from "react";

const DISMISS_KEY = "notice_seaway_2024_dismissed_until";
const DISMISS_MS = 7 * 24 * 60 * 60 * 1000;

function NoticeBar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissedUntil = window.localStorage.getItem(DISMISS_KEY);
    const dismissedUntilMs = dismissedUntil ? Number(dismissedUntil) : 0;
    if (!dismissedUntilMs || dismissedUntilMs < Date.now()) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    const dismissedUntil = Date.now() + DISMISS_MS;
    window.localStorage.setItem(DISMISS_KEY, String(dismissedUntil));
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-full border-b bg-boxbg sticky top-0 z-40">
      <div className="2xl:w-[60%] w-[90%] mx-auto px-3 py-3 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <p className="text-sm text-gray-900 md:text-base leading-6">
          천사뱃길 앱 지원은 종료되었습니다. 운항·안전 정보 안내는 2024
          스마트빌리지 사업으로 병풍도·대기점도·소악도에서 계속 제공됩니다.
        </p>
        <div className="flex items-center gap-3">
          <a
            href="https://searoad.co77iri.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="천사뱃길 홈페이지 새 탭 열기"
            className="inline-flex items-center justify-center px-3 py-1 text-sm font-semibold text-white bg-gray-950 rounded-full hover:opacity-80"
          >
            천사뱃길 홈페이지
          </a>
          <button
            type="button"
            onClick={handleClose}
            aria-label="공지 닫기"
            className="inline-flex items-center justify-center w-8 h-8 text-sm font-semibold text-gray-900 rounded-full hover:bg-boxbg2"
          >
            X
          </button>
        </div>
      </div>
    </div>
  );
}

export default NoticeBar;
